var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-83 -41)","fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"fill":"#E85E5E","x":"83","y":"41","width":"18","height":"18","rx":"9","key":0}),React.createElement("path",{"d":"M91.946 51.038h.484c.275 0 .45-.143.484-.43l.462-3.915v-.242c0-.285-.165-.45-.45-.45H91.46c-.297 0-.462.165-.462.45v.243l.462 3.916c.044.285.21.428.484.428zm.22 2.783c.66 0 1.166-.44 1.166-1.022 0-.605-.506-1.045-1.166-1.045-.66 0-1.155.44-1.155 1.045 0 .583.496 1.023 1.156 1.023z","fill":"#FFF","key":1})]));
}

Warning.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Warning;

Warning.default = Warning;



//////////////////
// WEBPACK FOOTER
// ./~/svg-react-loader/lib/loader.js!./src/components/UserMenu/components/Profile/warning.svg
// module id = 566
// module chunks = 0